import { NextRouter, useRouter } from 'next/router';
import { RootState, useTypedSelector } from 'lib/centralStore';

import { ULTIMI_RISULTATI_TEXT } from 'features/virtual/constants';
import { VirtualTopNavigationItem } from './components';
import { VirtualTopNavigationItem as VirtualTopNavigationItemType } from 'types/swagger';
import classNames from 'classnames';
import { memo } from 'react';
import { selectVirtualNav } from 'features/virtual/selectors';
import styles from './VirtualTopNavigation.module.scss';
import { useSelector } from 'react-redux';

export type VirtualTopNavigationProps = {
  noPadding?: boolean;
};

export const VirtualTopNavigation = memo(function VirtualTopNavigation({ noPadding }: VirtualTopNavigationProps) {
  const virtualNav = useTypedSelector(selectVirtualNav);

  const router = useRouter();
  const { isOpen } = useSelector((store: RootState) => store.carrello);

  const verifyCondition = (condition) => {
    if (condition) {
      return true;
    }
    return false;
  };

  const getIsActive = (menuItem: VirtualTopNavigationItemType, router: NextRouter) => {
    // sono in avvenimento
    if (!!router.query.avvenimento?.length) {
      return verifyCondition(
        `${menuItem?.slug}`.includes(router.query.disciplina as string) && menuItem.descrizione !== 'Ultimi risultati'
      );
    } else {
      // sono in top || disciplina || ultimi-risultati
      if (
        verifyCondition(menuItem.descrizione === ULTIMI_RISULTATI_TEXT && router.asPath.includes('ultimi-risultati'))
      ) {
        return true;
      } else {
        return `${menuItem?.slug}`.includes(router.asPath);
      }
    }
  };

  return (
    <nav className={classNames(styles.container)}>
      <div className={`${styles.wrapper}`}>
        <ul className={`${styles.list} ${noPadding || isOpen ? styles.noPadding : ''}`}>
          {virtualNav?.map((menuItem, index: number) => (
            <VirtualTopNavigationItem
              key={`${menuItem.idDisciplina}-${index}`}
              slug={menuItem.slug ?? ''}
              isActive={getIsActive(menuItem, router)}
              descrizione={menuItem.descrizione ?? ''}
              idDisciplina={`${menuItem.idDisciplina}`}
            />
          ))}
        </ul>
      </div>
    </nav>
  );
});
